import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDoubleLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 11,
	viewBox: "0 0 12 11",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "rotate(90 6 6)",
		children: [/* @__PURE__ */ _jsx("polygon", { points: "5.3 4.125 1.178 0 0 1.178 5.3 6.478 10.6 1.178 9.428 0" }), /* @__PURE__ */ _jsx("polygon", { points: "5.3 9.125 1.178 5 0 6.178 5.3 11.478 10.6 6.178 9.428 5" })]
	})
});
export default SvgArrowDoubleLeft;
